import consoleConfig from "console_config";

import type { ClientConfiguration } from "@packages/client";

const onBeforeRedirect = (location: string) => {
  if (
    location !== "/-/logout" &&
    location !== "/-/post-logout" &&
    location !== "/" &&
    location !== consoleConfig.URL_REDIRECT_AFTER_LOGOUT &&
    location !== consoleConfig.URL_LOGOUT
  ) {
    localStorage.setItem("auth-redirect-uri", location);
  }
};

// Use the default JS client on production
const config: ClientConfiguration = {
  response_mode: "web_message",
  response_type: "code",
  prompt: "none",
  api_url: consoleConfig.URL_API_PROXY,
  client_id: consoleConfig.ID_API_CLIENT,
  authentication_url: consoleConfig.URL_AUTH,
  authorization: consoleConfig.URL_AUTH
    ? `${consoleConfig.URL_AUTH}/oauth2/authorize`
    : `${consoleConfig.URL_ACCOUNTS}/oauth2/authorize`,
  logout_url: `${consoleConfig.URL_ACCOUNTS}/user/logout`,
  base_url: consoleConfig.URL_API_PROXY,
  // We need to ignore the same subdirectories as if we were on the auth url
  // when we have the landing page redirect for the brand merger. Otherwise
  // users will get redirected to the upsun login
  ignoredSubdirectories:
    window.location.origin === consoleConfig.URL_AUTH ||
    consoleConfig.CUSTOM_FULL_PAGE_REDIRECT
      ? ["/"]
      : undefined,
  onBeforeRedirect,
  authorize_params: consoleConfig.CUSTOM_SIGNUP_TARGET
    ? { signup_target: consoleConfig.CUSTOM_SIGNUP_TARGET }
    : undefined
};

export default config;
